import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import api from 'services/api/api';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const signUpAdmin = async body => {
	const url = '/auth/registerEmpresaAdminUser';
	const response = await api.post(url, body);
	return response.data;
};

export const useSignUpAdmin = (cleanFields: VoidFunction) => {
	const toast = useToast();
	return useMutation(signUpAdmin, {
		onSuccess: () => {
			toast({
				title: 'Usuário e Empresa criados com sucesso',
				description:
					'Usuário e empresa cadastrados com sucesso e um e-mail foi enviado para o usuário com as informações de acesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
			cleanFields();
		},
		onError: (error: any) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao cadastrar empresa!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
